import { useState, useEffect } from "react";
import '../css/NavBar.css';
import '../css/style.css'; 
import { NavLink } from "react-router-dom";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`navbar text-[#fff] p-5 px-8 tracking-widest uppercase ${isScrolled ? "scrolled" : ""}`}>
      {/* <div className='nav-main'><a href="/">SPRINGDALES THE SCHOOL</a></div> */}
      <div className="navbar-container">
        {/* Left Links */}
        <div className="nav-links left hidden md:flex">
          <NavLink to="/" className={({ isActive }) => isActive ? "active": ""}>Home</NavLink>
          <NavLink to="/about" className={({ isActive }) => isActive ? "active": ""}>About us</NavLink>
          <NavLink to="/programs" className={({ isActive }) => isActive ? "active": ""}>Our programs</NavLink>
        </div>

        {/* Logo */}
        <div className="nav-logo">
          <img
            src="https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621375/footer_ijnzf7.png?v=1"
            alt="Logo"
            className={`logo ${isScrolled ? "small" : ""}`}
          />
        </div>

        {/* Right Links */}
        <div className="nav-links right hidden md:flex">
          <NavLink to="/gallery" className={({ isActive }) => isActive ? "active": ""}>Our Gallery</NavLink>
          <NavLink to="/whyus" className={({ isActive }) => isActive ? "active": ""}>Why us</NavLink>
          <NavLink to="/contact" className={({ isActive }) => isActive ? "active": ""}>Contact us</NavLink>
        </div>
        <div className="md:hidden ml-auto hamburger cursor-pointer" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          ☰
        </div>
      </div>
      {isMenuOpen && (
        <div className="md:hidden mobile-menu">
          <NavLink to="/" onClick={() => setIsMenuOpen(false)} className="block">Home</NavLink>
          <NavLink to="/about" onClick={() => setIsMenuOpen(false)} className="block">About us</NavLink>
          <NavLink to="/programs" onClick={() => setIsMenuOpen(false)} className="block">Our programs</NavLink>
          <NavLink to="/gallery" onClick={() => setIsMenuOpen(false)} className="block">Our Gallery</NavLink>
          <NavLink to="/whyus" onClick={() => setIsMenuOpen(false)} className="block">Why us</NavLink>
          <NavLink to="/contact" onClick={() => setIsMenuOpen(false)} className="block">Contact Us</NavLink>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
